// import components
import {
  styled,
  IconButton,
  IconButtonProps,
  alpha,
  Box,
  BoxProps
} from '@mui/material';

export const StyledNotesSliderIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme }) => ({
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    position: 'absolute',
    width: '32px',
    height: '32px',
    top: '50%',
    // transform: 'translateY(-50%)',
    zIndex: 1,

    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.3)
    }
  })
);

export const StyledNoteSliderMotionBox = styled(Box)<BoxProps>(({}) => ({
  display: 'grid',
  overflow: 'hidden'
}));

export const StyledIndicatorBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<BoxProps & { isCompact?: boolean }>(({ theme, isCompact }) => ({
  position: 'absolute',
  bottom: isCompact ? 10 : 20,
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: theme.spacing(1),
  zIndex: 1
}));

export const sliderMotionAnimation = {
  enter: (direction: number) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0
  }),
  center: { x: 0, opacity: 1 },
  exit: (direction: number) => ({
    x: direction > 0 ? -300 : 300,
    opacity: 0
  })
};
